// NOTICE: KAPTION-INTEGRATION - Feature Permissions management store module
import * as types from '../mutation-types';
import featurePermissionsAPI from '../../api/featurePermissions';

const state = {
  features: [],
  areas: [],
  teams: [],
  members: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getFeatures(_state) {
    return _state.features;
  },
  getAreas(_state) {
    return _state.areas;
  },
  getTeams(_state) {
    return _state.teams;
  },
  getMembers(_state) {
    return _state.members;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_FEATURE_PERMISSIONS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await featurePermissionsAPI.get();
      commit(types.default.SET_FEATURE_PERMISSIONS, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_FEATURE_PERMISSIONS_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  async update({ commit }, featurePermissions) {
    commit(types.default.SET_FEATURE_PERMISSIONS_UI_FLAG, {
      isUpdating: true,
    });
    try {
      const response = await featurePermissionsAPI.update(featurePermissions);
      commit(types.default.UPDATE_FEATURE_PERMISSIONS, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_FEATURE_PERMISSIONS_UI_FLAG, {
        isUpdating: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_FEATURE_PERMISSIONS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_FEATURE_PERMISSIONS](_state, data) {
    _state.features = data.features || [];
    _state.areas = data.areas || [];
    _state.teams = data.teams || [];
    _state.members = data.members || [];
  },
  [types.default.UPDATE_FEATURE_PERMISSIONS](_state, data) {
    const updatedFeatures = data.features || [];
    updatedFeatures.forEach(updated => {
      const feature = _state.features.find(f => f.key === updated.key);
      if (feature) {
        feature.scope = updated.scope;
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
